import { FileResult } from "../../../admin/models/AdminProductsModels";
import api from "../../../core/api";
import { StockBatchUpload } from "../../inventory/models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.inventoryApiBaseUrl };
}

class CustomerStockItemsApi {
  uploadFile(model: StockBatchUpload): Promise<FileResult> {
    return api.post<FileResult>(`/stock-batches/bulk`, model, getRequestConfig())
      .then(x => x.data);
  }
}

export default new CustomerStockItemsApi();
